import {
  Check,
  CircleCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  createElement,
  KeyRound,
  LockKeyhole,
  LoaderCircle,
  Menu,
  ShieldCheck,
  X,
} from 'lucide';

const ICONS = {
  check: Check,
  confirmed: CircleCheck,
  expand: ChevronDown,
  back: ChevronLeft,
  close: X,
  forward: ChevronRight,
  key: KeyRound,
  lock: LockKeyhole,
  loading: LoaderCircle,
  menu: Menu,
  shield: ShieldCheck,
};

export function icon(name, className = 'icon') {
  const node = ICONS[name];
  if (!node) {
    throw new Error('Unknown interface icon');
  }

  const element = createElement(node, {
    width: 20,
    height: 20,
    'stroke-width': 1.8,
    'aria-hidden': 'true',
    focusable: 'false',
  });
  element.classList.add(...className.split(/\s+/u).filter(Boolean));
  return element;
}
